import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import Notifications from "../../components/Notifications"
function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
class AllNotifications extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listCheckbox: [],
            checkAll: false,
            all_notifications: JSON.parse(JSON.stringify(props.all_notifications)),
            sheetActive: false,
            selected: [],
            all_product: [],
            loading: props.loading,
            loadingEndPoint: false,
            nextCursor: "",
            textSearch: "",
            count_mail : props.count_mail,
            active: false,
        }
        // this.loadNotifications()
    }

    static getDerivedStateFromProps(props, state) {
        const { all_notifications, loading, count_mail } = props
        if (state.sent_notifications !== props.all_notifications) {
            return {
                all_notifications: JSON.parse(JSON.stringify(all_notifications)),
                loading,
                count_mail
                // listCheckbox: []
            }
        }
        // Return null to indicate no change to state.
        return null
    }


    handleSetWaitingSent = (clone) => {
        this.props.handleSetWaiting(clone)
    }

    handleReload = () => {
        this.props.handleReload()
    }

    render() {
        const {all_notifications, loading, count_mail} = this.state
        return (
            <Notifications
                count_mail = {count_mail}
                sendBulk={false}
                handleSetWaiting={this.handleSetWaitingSent}
                handleReload={this.handleReload}
                data_notifications={all_notifications}
                loading={loading}
            />
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AllNotifications)
